<div class="header_search">
  <div class="title-page">
    <h3>Projetos</h3>
  </div>
</div>

<div class="system-table table-container" *ngIf="!isLoading">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Projetos</th>
          <th>Órgão</th>
          <!-- <th>Previsto</th>
          <th>Executado</th> -->
          <th class="text-center">Status</th>
          <th>Atualização</th>
         <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let projeto of listaProjeto">
          <tr>
            <td class="title">
              <span class="title-span">{{projeto?.title}}</span>
              <div class="responsavel">
                <img *ngIf="projeto?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="projeto?.resp_nome" placement="bottom" (click)="viewResonsavel(projeto)">
                <div *ngIf="projeto?.level_priority" class="tag">Estratégico</div>
                <div *ngIf="projeto?.irfe_enabled_id" class="tag irfe">IRFE</div>
                <div *ngIf="projeto?.ircp_enabled_id" class="tag ircp">IRCP</div>
                <div *ngIf="hasTag(projeto, 144, 'pf_program')" class="tag plano_rio_grande">PLANO RIO GRANDE</div>
                <div *ngIf="hasTag(projeto, 172, 'pf_program')" class="tag plano_de_desenvolvimento">PLANO DESENVOLVIMENTO</div>
              </div>
            </td>
            <td>{{projeto?.agency_name}}</td>
            <!-- <td>{{projeto?.cron_foreseen_executed}}</td>
            <td>{{projeto?.cron_executed}}</td> -->
            <td class="status">
              <div *ngIf="projeto?.geral_analysis_status1 && projeto?.geral_analysis_stat_name">
                <span [innerHTML]="projeto?.geral_analysis_status1"></span>
                {{projeto?.geral_analysis_stat_name}}
              </div>
            </td>
            <td>
              {{projeto?.max_ctr_dth_atu}}
            </td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="view(projeto)">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!listaProjeto?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Projeto Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>